import * as React from "react";

import "./confirm-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {Link}           from "@Common/react/cst2";
import {UseState}       from "@Common/react/use-state";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";
import {upperCase1}     from "../../utils/strings";

export const ConfirmModal = ({next: rootNext}:{
    next    : Link<React.ReactNode, {
        show    : (props: {
            messageLines        : Array<string>,
            submessageLines    ?: Array<string>,
            confirmButtonLabel ?: string,
            cancelButtonLabel  ?: string,
            confirm             : () => void,
            onClose            ?: () => void,
        }) => void,
    }>,
}) => cs(
    ["confirming", (_, next) => UseState({next})],
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Confirm",
        next,
        rootNext,
    })],
    ["confirmError", (_, next) => UseState({next})],
    ({modal, confirming, confirmError}) => (
        <div className="confirm-modal-cm64 confirm-modal" xd-qa-type="modal" xd-qa-name="Approve Modal">
            <div className="content"> 
                {!confirmError.value && (confirming.value ? (
                    <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                        Processing request, please wait...
                    </div>
                 ) : (
                    <>
                        <div className="main-message-lines">
                            {modal.params.messageLines.map(messageLine => (
                                <div className="message-line">
                                    {messageLine}
                                </div>
                            ))}
                        </div>
                        <div className="sub-message-lines">
                            {modal.params.submessageLines && modal.params.submessageLines.map(submessageLine => (
                                <div className="submessage-line">
                                    {submessageLine}
                                </div>
                            ))}
                        </div>
                    </>
                 ))}

                {confirmError.value && <>
                    <div className="message" xd-qa-type="label" xd-qa-name="Request Failed">
                        Request failed to process:
                    </div>
                    <div className="sub-text error" xd-qa-type="label" xd-qa-name="Error Message">
                        {confirmError.value}
                    </div>
                </>}
            </div>

            <div className="footer">
                {!confirmError.value ? <>
                    {!confirming.value && (
                        <button {...{
                            className: "cancel",
                            onClick: () => modal.close(),
                            "xd-qa-type": "button",
                            "xd-qa-name": modal.params.cancelButtonLabel ? upperCase1(modal.params.cancelButtonLabel) : "Cancel",
                        }}>
                            {modal.params.cancelButtonLabel ? upperCase1(modal.params.cancelButtonLabel) : "Cancel"}
                        </button>
                    )}

                    <button {...{
                        className: "proceed",
                        disabled: confirming.value,
                        onClick: async () => {
                            confirming.onChange(true);
                            await modal.params.confirm();
                            confirming.onChange(false)
                            modal.close();
                        },
                        "xd-qa-type": "button",
                        "xd-qa-name": modal.params.confirmButtonLabel ? upperCase1(modal.params.confirmButtonLabel) : "OK",
                    }}>
                        {modal.params.confirmButtonLabel ? upperCase1(modal.params.confirmButtonLabel) : "OK"}
                    </button>
                </> : <>
                    <button {...{
                        className: "proceed",
                        onClick: () => modal.close(),
                        "xd-qa-type": "button",
                        "xd-qa-name": "Close",
                    }}>
                        Close
                    </button>
                </>}
            </div>
        </div>
    )
);
